import { Breadcrumb } from 'antd';
import { LayoutCMS } from 'components';
import React from 'react';
import { Link } from 'react-router-dom';
import TableStatics from './libraries';

export const PageStaticsComponent = (props: any) => {
    const title = 'Static Pages';
    const layoutCMSProps = {
        breadcrumb: (
            <>
                <Breadcrumb.Item>
                    <Link to="/settings/statics">{title}</Link>
                </Breadcrumb.Item>
            </>
        ),
        documentTitle: title,
        history: props.history,
        pageTitle: title,
    };
    return (
        <LayoutCMS {...layoutCMSProps}>
            <TableStatics />
        </LayoutCMS>
    );
};

export default PageStaticsComponent;



// WEBPACK FOOTER //
// ./src/pages/statics/component.tsx